import operateBtns from 'components/Refund/OperateBtns';
import { ReturnActionsProps } from './types';
import ContactBuyerBtn from '../ContactBuyerBtn';
import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { toUpperCase } from 'utils/toLowerCase';

export const ReturnActionShopee = (props: ReturnActionsProps) => {
  const { conversation, row, platform, refreshList, region } = props;
  const { t } = useTranslate();

  const {
    returnSn,
    orderSn,
    unit,
    refundAmount,
    latestOfferAmount,
    externalStoreId,
    internalStoreId,
    internalTradeId,
    operate = [],
    operationLog = [],
    offerCounterLimit = 1,
    displayStatus,
    allowOffer = [],
    preDispute,
    externalBuyerId,
    buyerNick,
  } = row;

  const optBtns = operateBtns({
    externalStoreId,
    externalTradeId: orderSn,
    returnSn,
    operate,
    refreshList,
    internalStoreId,
    internalTradeId: `${internalTradeId}`,
    displayStatus,
    unit,
    refundAmount,
    latestOfferAmount,
    allowOffer,
    offerCounterLimit,
    operationLog,
    platform,
    preDispute,
    region,
    uiContactBuyerBtn: (
      <ContactBuyerBtn
        orderSn={orderSn}
        region={toUpperCase(region) as General.UpperCaseRegion}
        externalBuyerId={externalBuyerId}
        externalStoreId={externalStoreId}
        buyerNick={buyerNick}
        returnSn={returnSn}
        type="refund"
        onClose={refreshList}
        conversation={conversation}
        ghost={false}
      />
    ),
  }).filter((v) => v !== null);

  return (
    <>
      {optBtns.length <= 3
        ? optBtns
        : [
            optBtns.slice(0, 2),
            <Dropdown
              className="pl-2"
              key="moreRefundBtns"
              overlay={<div className="moreBtns">{optBtns.slice(2)}</div>}
              getPopupContainer={(trigger) => trigger}
            >
              <Space>
                {t('scene.orderWorkspace.returnRefundTab.detail.action.moreActions')}
                <DownOutlined />
              </Space>
            </Dropdown>,
          ]}
    </>
  );
};
